import React from 'react'

const Card = ({ link, imgUrl, title, subTitle, extraClass, description, ...rest }) => {
    return (
        <li className={`border border-solid border-gray-800 card overflow-hidden relative w-full ${extraClass}`} style={{ height: '350px' }} >
            <a href={link} className="flex h-full w-full justify-start items-center" target="_blank" rel="noopener noreferrer">
                <img className="img w-full absolute top-0 left-0 object-cover mb-2" style={{ filter: 'brightness(40%)', height: '350px' }} src={imgUrl} alt="card" />
                <div className="p-8 text-left z-10">
                    <h1 className="text-white font-bold text-3xl">{title} - {subTitle}</h1>
                    <p className="text-white font-semibold text-sm">{description}</p>
                </div>
            </a>
        </li>
    )
}


export default () => {
    return (
        <div className="section portfolio">
            <div id="portfolio" style={{ transform: 'translateY(-68px)' }} />
            <div className="container text-white text-center py-16  p-4">
                <div className="mb-8 flex flex-col items-center">
                    <h3 className="text-main text-3xl border-b border-solid border-main">Portfolio</h3>
                </div>

                <ul className="w-full grid lg:grid-cols-3 grid-cols-1 gap-6">
                    <Card
                        link="https://github.com/LuisTessaro/gadablog-react-frontend"
                        imgUrl="https://i.imgur.com/9eEX44k.png"
                        title="Personal Blog"
                        subTitle="Fullstack"
                        extraClass="col-span-3"
                        description="Blog and API with complete content manager"
                    />

                    <Card
                        link="https://github.com/LuisTessaro/webtoapp-spotify-api"
                        imgUrl="https://assets.b9.com.br/wp-content/uploads/2018/10/Spotify-Dark-1280x720.jpg"
                        title="Spotify URL Minifier"
                        subTitle="Backend"
                        extraClass="lg:col-span-2 col-span-3"
                        description="Turns a ulr into a direct link to the Spotify app"
                    />

                    <Card
                        link="https://pland.com.br"
                        imgUrl="https://i.imgur.com/8ejhVBl.png"
                        title="PlanD Site"
                        subTitle="Frontend"
                        extraClass="lg:col-span-1 col-span-3"
                        description="Institutional Website complete with a implementation of my Blog"
                    />


                    <Card
                        link="https://github.com/LuisTessaro/luistessaro.github.io"
                        imgUrl="https://i.imgur.com/72hrnu7.png"
                        title="This Site"
                        subTitle="Frontend"
                        extraClass="lg:col-span-1 col-span-3"
                        description="My own cv site using no templates"
                    />

                    <Card
                        link="https://github.com/LuisTessaro/RPG-Telegram-bot"
                        imgUrl="https://i.imgur.com/sVVE5lW.png"
                        title="RPG Telegram Bot"
                        subTitle="Backend/Game"
                        extraClass="lg:col-span-2 col-span-3"
                        description="A semi-idle rpg experience for Telegram, uses the Pokemon battle style combat"
                    />

                    <Card
                        link="https://github.com/LuisTessaro/Express-Example"
                        imgUrl="https://code.visualstudio.com/assets/docs/nodejs/nodejs/debugsession.png"
                        title="Express Example"
                        subTitle="Backend"
                        extraClass="col-span-3"
                        description="A tutorial on backend disguised as a boilerplate/example"
                    />

                </ul>

            </div>
        </div>
    )
}